import { Navigate, Route, Routes } from 'react-router-dom';
import GoogleSignIn from './auth/GoogleSignIn';
import AppShell from './components/AppShell';
import PublicLayout from './components/PublicLayout';
import HistoryView from './views/HistoryView';
import SnippetsView from './views/SnippetsView';
import SettingsView from './views/SettingsView';
import AccountView from './views/AccountView';
import HomeView from './views/HomeView';
import PlansView from './views/PlansView';
import DictionaryView from './views/DictionaryView';
import LandingView from './views/LandingView';
import PrivacyView from './views/PrivacyView';
import TermsView from './views/TermsView';
import AccountDeleteView from './views/AccountDeleteView';

/**
 * App — SPA routes for the single Loaf web application (Obsidian Companion).
 *
 * Public routes (no auth required):
 *   /                → landing page
 *   /privacy         → privacy policy
 *   /terms           → terms of service
 *   /account/delete  → public account deletion (GIS-verified, no session)
 *   /auth            → Google sign-in (GIS) → POST /auth/web → cookie → /app/home
 *
 * Protected routes (auth-guarded, NavRail shell):
 *   /app             → redirect to /app/home
 *   /app/home        → readiness + activity metrics + recent transcriptions/snippets
 *   /app/history     → dictation/AI conversation history (two-pane)
 *   /app/snippets    → snippet management (card grid + side panel)
 *   /app/settings    → grouped settings (category nav)
 *   /app/account     → profile + subscription + destructive
 *   /app/plans       → Free/Pro plan comparison (external Google Play billing)
 *   /app/dictionary  → personal dictionary (empty state — managed on Android)
 *
 * Cloudflare Pages _redirects sends /* to /index.html so all client
 * routes resolve on hard refresh / deep link.
 */
export default function App() {
  return (
    <Routes>
      {/* Public routes — shared header/footer shell */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<LandingView />} />
        <Route path="/privacy" element={<PrivacyView />} />
        <Route path="/terms" element={<TermsView />} />
        <Route path="/account/delete" element={<AccountDeleteView />} />
      </Route>

      {/* Auth — standalone (no public layout chrome) */}
      <Route path="/auth" element={<GoogleSignIn />} />

      {/* Protected routes — NavRail shell, auth-guarded via /account 401 */}
      <Route path="/app" element={<AppShell />}>
        <Route index element={<Navigate to="/app/home" replace />} />
        <Route path="home" element={<HomeView />} />
        <Route path="history" element={<HistoryView />} />
        <Route path="snippets" element={<SnippetsView />} />
        <Route path="settings" element={<SettingsView />} />
        <Route path="account" element={<AccountView />} />
        <Route path="plans" element={<PlansView />} />
        <Route path="dictionary" element={<DictionaryView />} />
      </Route>

      {/* Catch-all → landing page */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
